import { AuthService } from '../services/auth.service';
var JwtInterceptor = /** @class */ (function () {
    function JwtInterceptor(authService) {
        this.authService = authService;
    }
    JwtInterceptor.prototype.intercept = function (request, next) {
        var currentSession = this.authService.currentSessionValue;
        var authURL = /\/auth\//gi;
        if (request.url.search(authURL) === -1 && currentSession && currentSession.jwt) {
            var headerParams = {
                Authorization: "Bearer " + currentSession.jwt,
                userName: currentSession.username,
                'x-id': currentSession.username
            };
            if (currentSession.branchOffice) {
                headerParams['x-branchOffice'] = currentSession.branchOffice.toString();
            }
            request = request.clone({
                setHeaders: headerParams
            });
        }
        return next.handle(request);
    };
    return JwtInterceptor;
}());
export { JwtInterceptor };
